<template>
  <div id="privacyPolicy">
    <div class="head">
      <H3>{{title}}</H3>
    </div>
    <div class="content">
      武汉彩点科技有限公司（以下简称为“彩点科技”、“我们”或“我们的”）充分尊重您的隐私权。我们特此制定本《彩点科技消费者业务隐私政策》以便您了解我们如何搜集、使用、披露、保护、存储及传输您的个人数据。请您仔细阅读本声明。如您有任何疑问，请告知我们。
      <br>彩点科技为了给您提供更准确、更有个性化的服务，我们会按照本隐私权政策的规定范围合理使用您的个人信息。但彩点科技将以高度的勤勉、审慎义务对待这些信息，除本隐私权政策另有规定外，在未征得您事先许可的情况下，我们不会将这些信息对外披露或向第三方提供。彩点科技会不时更新本隐私权政策。您在同意彩点科技服务使用协议之时，即视为您已经同意本隐私权政策全部内容。本隐私权政策属于武汉彩点科技有限公司网络服务使用协议不可分割的一部分。
      <br>1. 适用范围
      <br>A）在您注册彩点科技帐号时，您根据我们要求提供的个人注册信息；
      <br>B）在您使用彩点科技旗下APP及网络服务时，或访问彩点科技平台网页时，我们自动接收并记录的您的浏览器和计算机上的部分信息，包括但不限于您的IP地址、使用的语言、访问日期、浏览记录、访问时间及您需求的网页记录等数据；
      <br>C）您在使用彩点科技平台提供的搜索服务时输入的关键字信息；
      <br>D）我们收集到的您在我们平台发布的有关信息数据，包括但不限于参与活动、成交信息及评价详情；
      <br>您了解并同意，以下信息不适用本隐私权政策：
      <br>A）违反法律规定或违反彩点科技规则行为及我们已对您采取的措施。
      <br>2. 信息使用
      <br>a) 彩点科技不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可，或该第三方和我们单独或共同为您提供服务，且在该服务结束后，其将被禁止访问包括其以前能够访问的所有这些资料。
      <br>b) 彩点科技亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何彩点科技平台工作人员或用户如从事上述活动，一经发现，彩点科技有权立即终止与该人员的工作协议或用户的服务协议。
      <br>c) 为服务用户的目的，彩点科技可能通过使用您的个人信息，向您提供您感兴趣的信息，包括但不限于向您发出产品和服务信息，或者与彩点科技合作伙伴共享信息以便他们向您发送有关其产品和服务的信息（后者需要您的事先同意）。
      <br>3. 信息披露
      <br>在如下情况下，彩点科技将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：
      <br>a) 经您事先同意，向第三方披露；
      <br>b) 为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；
      <br>c) 根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；
      <br>d) 如您出现违反中国有关法律、法规或者彩点科技服务协议或相关规则的情况，需要向第三方披露；
      <br>e) 在彩点科技平台上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，我们有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决。
      <br>f) 其它彩点科技根据法律、法规或者网站政策认为合适的披露。
      <br>4. 信息存储和交换
      <br>彩点科技收集的有关您的信息和资料将保存在彩点科技的服务器上，这些信息和资料可能传送至您所在国家、地区或彩点科技收集信息和资料所在地的境外并在境外被访问、存储和展示。
      <br>5. Cookie的使用
      <br>a) 在您未拒绝接受cookies的情况下，彩点科技会在您的计算机或移动设备上设定或取用cookies，以便您能登录或使用依赖于cookies的彩点科技平台服务或功能。彩点科技使用cookies可为您提供更加周到的个性化服务，包括推广服务。
      <br>b) 您有权选择接受或拒绝接受cookies。您可以通过修改浏览器设置的方式拒绝接受cookies。但如果您选择拒绝接受cookies，则您可能无法登录或使用依赖于cookies的彩点科技网络服务或功能。
      <br>c) 通过彩点科技所设cookies所取得的有关信息，将适用本政策。
      <br>6. 信息安全
      <br>a) 彩点科技的帐号均有安全保护功能，请妥善保管您的用户名及密码信息。彩点科技将通过对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您注意在信息网络上不存在“完善的安全措施”。
      <br>b) 在使用彩点科技网络服务进行信息分享时，您不可避免的要向分享方披露自己的个人信息，如联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是彩点科技平台的用户名及密码发生泄露，请您立即联络我们的客服，以便我们采取相应措施。

    </div>
  </div>
</template>

<script>
  export default {
    name: 'privacyPolicy',
    data() {
      return {
        title: '隐私政策',
      }
    },
    components: {},
    created() {
    },
    methods: {}
  }
</script>

<style scoped lang="less">
  #privacyPolicy {
    .head{
      height: 90px;
      border-bottom: 1px solid #dedede;
      h3{
        font-size: 24px;
        font-weight: bold;
        line-height: 90px;
        padding-left: 20px;
        color: #5E5E5E;
      }
    }
    .content{
      padding: 30px 50px;
      font-size: 16px;
      line-height: 30px;

    }
  }
</style>



// WEBPACK FOOTER //
// src/views/privacyPolicy.vue